import api from "core/api/axiosInstance";
import { isConcessionResponseKey } from "./conciliationKeyFormat";
import { buildPeajePayment } from "./peajePayment";
const tieneDato = (value) => value != null && String(value).trim() !== "";

export function validateConcessionResponse({
  key_concil,
  code,
  value_concil,
  steps,
  observation,
  file,
  more = {},
  peajePayment,
}) {
  if (!isConcessionResponseKey(key_concil)) throw new Error("La llave no es válida.");
  if (!/^\d+$/.test(String(code || "")) || !Number.isSafeInteger(Number(code)))
    throw new Error("El código de concesión no es válido.");
  if (
    tieneDato(steps) &&
    (!/^\d+$/.test(String(steps)) || !Number.isSafeInteger(Number(steps)) || Number(steps) < 0)
  )
    throw new Error("Ingresa una cantidad de pasos entera, igual o mayor que cero.");
  if (tieneDato(steps) && !tieneDato(value_concil))
    throw new Error("Si ingresas pasos, completa también el valor total.");
  if (
    tieneDato(value_concil) &&
    (!/^\d+(\.\d{1,2})?$/.test(String(value_concil)) || !Number.isFinite(Number(value_concil)))
  )
    throw new Error("Ingresa un valor total igual o mayor que cero, con máximo dos decimales.");
  if (observation != null && typeof observation !== "string")
    throw new Error("La observación no es válida.");
  if (!more || typeof more !== "object" || Array.isArray(more))
    throw new Error("El desglose de peajes no es válido.");
  const desgloseValido = (detail) =>
    (detail?.steps == null || (Number.isSafeInteger(detail.steps) && detail.steps >= 0)) &&
    typeof detail?.value === "number" &&
    Number.isFinite(detail.value) &&
    detail.value >= 0 &&
    Number.isSafeInteger(Math.round(detail.value * 100));
  let totalSteps = 0,
    totalCents = 0;
  Object.entries(more).forEach(([name, llaves]) => {
    if (peajePayment && name.trim() && llaves === null) return;
    if (
      !name.trim() ||
      !llaves ||
      typeof llaves !== "object" ||
      Array.isArray(llaves) ||
      !Object.keys(llaves).length
    )
      throw new Error("El desglose de peajes no es válido.");
    Object.entries(llaves).forEach(([llave, detail]) => {
      if (!String(llave).trim() || !desgloseValido(detail))
        throw new Error("El desglose de peajes no es válido.");
      totalSteps += detail.steps ?? 0;
      totalCents += Math.round(detail.value * 100);
    });
  });
  const payment = peajePayment
    ? buildPeajePayment(peajePayment.rows, peajePayment.peaje, peajePayment.response)
    : null;
  if (payment && (!file || JSON.stringify(more) !== JSON.stringify(payment.more)))
    throw new Error("Adjunta el Excel del peaje que vas a reportar.");
  if (
    (payment ? payment.steps : totalSteps) !== Number(steps || 0) ||
    (payment ? Math.round(Number(payment.value_concil) * 100) : totalCents) !==
      Math.round(Number(value_concil || 0) * 100)
  )
    throw new Error("Los totales no coinciden con el desglose de peajes.");
  if (
    file &&
    (!(file instanceof File) ||
      !/\.(xlsx|xls)$/i.test(file.name) ||
      !file.size ||
      file.size > 10 * 1024 * 1024)
  )
    throw new Error("Adjunta un Excel .xlsx o .xls con contenido, de máximo 10 MB.");
}

export async function sendConcessionResponse(values, signal) {
  if (!localStorage.getItem("token"))
    throw new Error("Tu sesión expiró. Inicia sesión nuevamente.");
  validateConcessionResponse(values);
  const more = Object.fromEntries(
    Object.entries(values.more || {}).map(([peaje, turnos]) => [
      peaje,
      turnos === null
        ? null
        : Object.fromEntries(
            Object.entries(turnos).map(([turno, detail]) => [
              turno,
              {
                ...detail,
                ...((!values.peajePayment || peaje === values.peajePayment.peaje) &&
                tieneDato(values.observation)
                  ? { observation: values.observation.trim() }
                  : {}),
              },
            ])
          ),
    ])
  );
  if (!Object.keys(more).length && tieneDato(values.observation))
    more.observation = values.observation.trim();
  const fields = {
    code: Number(values.code),
    key_concil: String(values.key_concil),
    ...(tieneDato(values.value_concil) ? { value_concil: Number(values.value_concil) } : {}),
    steps: Number(values.steps ?? 0),
    more: JSON.stringify(more),
  };
  const body = new FormData();
  Object.entries(fields).forEach(([key, value]) => body.append(key, String(value)));
  if (values.file) body.append("files", values.file);
  try {
    const { data } = await api.post("/api/conciliation/send-conciliation-response", body, {
      signal,
      timeout: 30000,
      // El navegador agrega el boundary al enviar el FormData.
      headers: { "Content-Type": undefined },
    });
    const code = data?.code;
    if (
      data?.success === false ||
      data?.success === "false" ||
      (code != null && Number(code) !== 0 && !(Number(code) >= 200 && Number(code) < 300))
    )
      throw new Error(data?.message || data?.msm || "El servidor rechazó el reporte.");
    return data;
  } catch (error) {
    if (signal?.aborted) throw error;
    const message = error.response?.data?.message || error.response?.data?.msm;
    throw new Error(
      error.response
        ? `HTTP ${error.response.status}: ${message || "No se pudo enviar el reporte."}`
        : error.request || error.code === "ECONNABORTED"
        ? "No se pudo confirmar el envío. Verifica si se recibió antes de volver a enviarlo."
        : error.message
    );
  }
}
